import {getBenefitsByGroup} from "./getBenefitsByGroup";

export const getValuesByGroup = (groupName, entities, data) => {
  return Object.entries(entities)
    .filter(([_, value]) => value)
    .map(([key]) => getBenefitsByGroup(groupName, data).find(i => i.value === key).id)
    .join(",");
}